import { createUseStyles } from 'react-jss'
import { bannerGrey } from '../../../../../../../../styles/const/colors'

const useStyles = createUseStyles({
  icon: {
    minWidth: 16,
    minHeight: 16,
    marginRight: 8,
    '& svg': {
      height: 16,
      width: 16
    }
  },
  emptyIcon: {
    extend: 'icon',
    display: 'inline-block',
    background: bannerGrey,
    borderRadius: '50%'
  }
})

export default useStyles
